import React from 'react';

import style from './StatsPanel.css';

const openCloseStats = (visible, available) => {
  if (available > visible) return style.toggleCount;
  return `${style.toggleCount} ${style.closeStats}`;
};

const StatBox = ({ stat, localizedLabel }) => {
  const label = localizedLabel || stat.label;
  return (
    <div className={`${style.stat} ${style[stat.id]}`}>
      <div className={style.label}>{label}</div>
      <div className={style.value} data-measure={stat.measure}>
        {stat.value}
      </div>
    </div>
  );
};

const Expander = ({ maxCount, visCount, minCount, toggleVisible }) => {
  if (maxCount <= minCount) return null;
  return (
    <div
      className={openCloseStats(visCount, maxCount)}
      onClick={() => {
        toggleVisible(visCount < maxCount ? maxCount : minCount);
      }}
    >
      Stats
      <div>
        <svg xmlns='http://www.w3.org/2000/svg' width='16px' height='12px'>
          <g fill='none'>
            <polyline stroke='rgb(240,240,240)' strokeWidth='2' points='0 2 8 10 16 2' />
          </g>
        </svg>
      </div>
    </div>
  );
};

const StatsPanel = ({
  statsArr = [],
  numberVisible = 0,
  numberAvailable = 0,
  defaultStatsVisible = 0,
  statLabelsLocalized = {},
  toggleVisible,
  showModal,
}) => {
  if (showModal) return null;
  return (
    <div className={style.statsPanel}>
      <div className={style.statsList}>
        {statsArr.slice(0, numberVisible).map(stat => (
          <StatBox key={stat.label} stat={stat} localizedLabel={statLabelsLocalized[stat.id]} />
        ))}
      </div>
      <Expander
        minCount={defaultStatsVisible}
        maxCount={numberAvailable}
        visCount={numberVisible}
        toggleVisible={toggleVisible}
      />
    </div>
  );
};

export default StatsPanel;
